import { Lightning, Utils } from "@lightningjs/sdk";
import { FOCUS_TRANSITION } from "../base/focus";
const BRAND_BLUE = 0xff085fff;
export class NavbarItem extends Lightning.Component {
    constructor() {
        super(...arguments);
        this._item = { id: "", kind: "label" };
        this._activePage = false;
    }
    static _template() {
        return {
            h: 68,
            flex: {
                direction: "row",
                alignItems: "center",
                justifyContent: "center",
            },
            flexItem: { shrink: 0 },
            ActiveBackground: {
                w: (w) => w,
                h: 68,
                flexItem: false,
                rect: true,
                color: 0xffffffff,
                alpha: 0,
                shader: { type: Lightning.shaders.RoundedRectangle, radius: 8 },
            },
            Background: {
                w: (w) => w,
                h: 68,
                flexItem: false,
                rect: true,
                color: 0xffffffff,
                alpha: 0,
                shader: { type: Lightning.shaders.RoundedRectangle, radius: 8 },
            },
            Label: {
                visible: false,
                flexItem: { marginLeft: 24, marginRight: 24, shrink: 0 },
                text: {
                    fontFace: "Insatiable Display",
                    fontStyle: "700",
                    fontSize: 32,
                    // Keep fixed-height text textures proportional at 720p as well as 1080p.
                    precision: 1,
                    h: 36,
                    lineHeight: 36,
                    offsetY: 30,
                    textColor: 0xffffffff,
                    wordWrap: false,
                },
            },
            Search: { visible: false, w: 40.001, h: 40 },
            Avatar: {
                visible: false,
                w: 68,
                h: 68,
                flexItem: false,
                // The export includes the portrait crop from the Figma account slot.
                rtt: true,
                shader: { type: Lightning.shaders.RoundedRectangle, radius: 8 },
                Portrait: {
                    w: 68,
                    h: 68,
                    src: Utils.asset("images/navbar/profile.jpg"),
                },
            },
            ProfileBorder: {
                visible: false,
                w: 68,
                h: 68,
                flexItem: false,
                rect: true,
                shader: {
                    type: Lightning.shaders.RoundedRectangle,
                    radius: 8,
                    fillColor: 0x00ffffff,
                    stroke: 1,
                    strokeColor: 0xffffffff,
                },
            },
            ProfileFocusBorder: {
                visible: false,
                w: 68,
                h: 68,
                flexItem: false,
                rect: true,
                alpha: 0,
                shader: {
                    type: Lightning.shaders.RoundedRectangle,
                    radius: 8,
                    fillColor: 0x00ffffff,
                    stroke: 3,
                    strokeColor: 0xffffffff,
                },
            },
            ClubBadge: {
                visible: false,
                x: 50,
                y: -7,
                w: 30,
                h: 30,
                flexItem: false,
                texture: Lightning.Tools.getSvgTexture(Utils.asset("images/navbar/profile-psg.svg"), 60, 60),
            },
        };
    }
    get itemId() {
        return this._item.id;
    }
    set item(item) {
        var _a, _b;
        this._item = item;
        const { kind } = item;
        this.patch({
            w: kind === "search" || kind === "profile" ? 68 : 0,
            Label: {
                visible: kind === "label",
                text: {
                    text: (_a = item.label) !== null && _a !== void 0 ? _a : "",
                    letterSpacing: (_b = item.letterSpacing) !== null && _b !== void 0 ? _b : 0,
                },
            },
            Search: { visible: kind === "search" },
            Avatar: { visible: kind === "profile" },
            ProfileBorder: { visible: kind === "profile" },
            ProfileFocusBorder: { visible: kind === "profile" },
            ClubBadge: { visible: kind === "profile" },
        });
        this.updateAppearance();
    }
    set activePage(active) {
        this._activePage = active;
        this.updateAppearance();
    }
    _focus() {
        this.updateAppearance();
    }
    _unfocus() {
        this.updateAppearance();
    }
    updateAppearance() {
        const focused = this.hasFocus();
        const { kind } = this._item;
        this.tag("ActiveBackground").alpha =
            this._activePage && kind !== "profile" ? 0.2 : 0;
        this.tag("Background").setSmooth("alpha", focused && kind !== "profile" ? 1 : 0, FOCUS_TRANSITION);
        this.tag("Label").patch({
            text: { textColor: focused ? BRAND_BLUE : 0xffffffff },
        });
        if (kind === "search") {
            this.tag("Search").patch({
                color: focused ? BRAND_BLUE : 0xffffffff,
                texture: this.iconTexture("search", 40.001, 40),
            });
        }
        else if (kind === "profile") {
            this.tag("ProfileFocusBorder").setSmooth("alpha", focused ? 1 : 0, FOCUS_TRANSITION);
        }
    }
    iconTexture(name, w, h) {
        return Lightning.Tools.getSvgTexture(Utils.asset(`images/navbar/${name}.svg`), Math.ceil(w * 2), Math.ceil(h * 2));
    }
}
export default NavbarItem;
//# sourceMappingURL=NavbarItem.js.map